import React, { useState } from 'react'
import { Box, Button, CircularProgress, Grid } from '@mui/material'
import { ROUTES } from '../../router'
import LinkCard, { LinkCardProps } from './components/LinkCard'
import { AdminPanelSecObjects } from 'src/types/security'
import { SafetyComponent } from 'src/components/security'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import GroupsIcon from '@mui/icons-material/Groups'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import ApartmentIcon from '@mui/icons-material/Apartment'
import HistoryIcon from '@mui/icons-material/History'
import BusinessIcon from '@mui/icons-material/Business'
import AssessmentIcon from '@mui/icons-material/Assessment'
import CategoryIcon from '@mui/icons-material/Category'
import SecurityIcon from '@mui/icons-material/Security'
import CachedIcon from '@mui/icons-material/Cached'
import toast from 'react-hot-toast'
import { HttpCacheGeneral } from 'src/http/httpCacheGeneral'

const cardLinkProps: LinkCardProps[] = [
    {
        to: ROUTES.USUARIOS,
        title: 'Usuarios',
        icon: ManageAccountsIcon,
        color: '#4f46e5',
        securityObject: AdminPanelSecObjects.LinkTablaUsuarios
    },
    {
        to: ROUTES.GRUPOS,
        title: 'Grupos',
        icon: GroupsIcon,
        color: '#0891b2',
        securityObject: AdminPanelSecObjects.LinkTablaGrupos
    },
    // {
    //     to: ROUTES.ETAPAS,
    //     title: 'Etapas',
    //     icon: AccountTreeIcon,
    //     color: '#059669',
    //     securityObject: AdminPanelSecObjects.LinkTablaEtapas
    // },
    {
        to: ROUTES.SECTORES_COMERCIALES,
        title: 'Sectores Comerciales',
        icon: ApartmentIcon,
        color: '#dc2626',
        securityObject: AdminPanelSecObjects.LinkTablaSectoresComerciales
    },
    {
        to: ROUTES.UNIDADES_NEGOCIO,
        title: 'Unidades de Negocio',
        icon: BusinessIcon,
        color: '#0d9488',
        securityObject: AdminPanelSecObjects.LinkTablaUnidadesNegocio
    },
    {
        to: ROUTES.CLIENTE_TIPO,
        title: 'Tipo / Subtipo Cliente LCLS',
        icon: CategoryIcon,
        color: '#ea580c',
        securityObject: AdminPanelSecObjects.LinkTablaClienteTipo
    },
    {
        to: ROUTES.CLIENTE_TIPO_LCTC,
        title: 'Tipo / Subtipo Cliente LCTC',
        icon: CategoryIcon,
        color: '#7c3aed',
        securityObject: AdminPanelSecObjects.LinkTablaClienteTipoLCTC
    },
    {
        to: ROUTES.SECTOR_SISTEMA_GRUPO,
        title: 'Sector - Sistema - Grupo',
        icon: AccountTreeIcon,
        color: '#059669',
        securityObject: AdminPanelSecObjects.LinkTablaSectorSistemaGrupo
    },
    {
        to: ROUTES.ETAPA_ENVIO_MAIL,
        title: 'Envío Mail Extra por Etapa',
        icon: HistoryIcon,
        color: '#6366f1',
        securityObject: AdminPanelSecObjects.LinkTablaEtapaEnvioMail
    },
    {
        to: ROUTES.REPORTES,
        title: 'Reportes de Control',
        icon: AssessmentIcon,
        color: '#be185d',
        securityObject: AdminPanelSecObjects.LinkTablaReportes
    },
    {
        to: ROUTES.EVENTOS,
        title: 'Eventos',
        icon: HistoryIcon,
        color: '#7c3aed',
        securityObject: AdminPanelSecObjects.LinkTablaEventos
    }
]

function Admin() {
    const [refreshing, setRefreshing] = useState(false)

    const handleRefreshCache = () => {
        setRefreshing(true)
        const promise = HttpCacheGeneral.refreshAll()
        toast.promise(promise, {
            loading: 'Actualizando cachés...',
            success: 'Cachés actualizados correctamente',
            error: 'Error al actualizar cachés'
        }).finally(() => setRefreshing(false))
    }

    return (
        <>
            <SafetyComponent code={AdminPanelSecObjects.BotonRefrescarCaches}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
                    <Button
                        variant='outlined'
                        startIcon={refreshing ? <CircularProgress size={18} /> : <CachedIcon />}
                        onClick={handleRefreshCache}
                        disabled={refreshing}
                    >
                        Refrescar Cachés
                    </Button>
                </Box>
            </SafetyComponent>
            <Grid container spacing={3}>
                {cardLinkProps.map((cardProps, index) => (
                    <SafetyComponent code={cardProps.securityObject!}>
                        <Grid key={index} item xs={6} sm={4} md={3}>
                            <LinkCard {...cardProps} />
                        </Grid>
                    </SafetyComponent>
                ))}
                <Grid item xs={6} sm={4} md={3}>
                    <LinkCard
                        to={ROUTES.INSTRUMENTOS_LCSLHPTI}
                        title='Instrumentos LCSLHPTI'
                        icon={CategoryIcon}
                        color='#2563eb'
                    />
                </Grid>
                <Grid item xs={6} sm={4} md={3}>
                    <LinkCard
                        to={`/${ROUTES.ADMIN_MASTER}`}
                        title='Admin Master'
                        icon={SecurityIcon}
                        color='#b45309'
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default Admin
